import { render, staticRenderFns } from "./advertisementtwo.vue?vue&type=template&id=458b10b3&"
import script from "./advertisementtwo.vue?vue&type=script&lang=js&"
export * from "./advertisementtwo.vue?vue&type=script&lang=js&"
import style0 from "./advertisementtwo.vue?vue&type=style&index=0&id=458b10b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports